import {readStorageRequest, completeStorageTransaction} from './chat-database.js';
export type PendingOwner = {workspaceId: string; userId: string; epoch: string};
export type PendingSnapshot = Record<string, unknown>[];
function belongsTo(item: Record<string, unknown>, owner: PendingOwner): boolean {
  return item.workspace_id === owner.workspaceId && item.user_id === owner.userId && (item.local_epoch ?? '') === owner.epoch;
}
export async function readPendingSnapshot(db: IDBDatabase, owner: PendingOwner): Promise<PendingSnapshot> {
  const items = await readStorageRequest(db.transaction('pending').objectStore('pending').getAll()) as PendingSnapshot;
  return items.filter(item => belongsTo(item, owner));
}
/** Delete only the exact confirmed snapshot; changed/new/foreign rows cannot be swept. */
export async function clearPendingSnapshot(db: IDBDatabase, owner: PendingOwner, snapshot: PendingSnapshot, valid: () => boolean): Promise<void> {
  if (!valid()) throw new Error('Аккаунт изменился. Очередь не удалена.');
  if (!snapshot.length) return;
  const tx = db.transaction('pending', 'readwrite'), store = tx.objectStore('pending');
  const completion = completeStorageTransaction(tx);
  let refusal: Error | undefined;
  for (const expected of snapshot) {
    const request = store.get(expected.client_message_id as IDBValidKey);
    request.onsuccess = () => {
      const actual = request.result as Record<string, unknown> | undefined;
      if (!valid() || !belongsTo(expected, owner) || !actual || !belongsTo(actual, owner) || JSON.stringify(actual) !== JSON.stringify(expected)) {
        refusal = new Error('Очередь или аккаунт изменились. Ничего не удалено; повторите проверку.');
        tx.abort(); return;
      }
      store.delete(expected.client_message_id as IDBValidKey);
    };
  }
  try { await completion; } catch (error) { throw refusal ?? error; }
}
